import React from 'react'
import './loading-screen.css'

const LoadingScreen = () => {
  return (
    <div className="loading">
       <h1>Sto caricando...</h1> 
    </div>
  )
}

export default LoadingScreen